module.exports = __webpack_public_path__ + "static/media/fist.0aa7fbdb.svg";